import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ComponentFactoryResolver,
  ViewChild,
} from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../core/config/Constants';
import { UtilityService } from '../../core/services/utility.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { Category } from '../../core/models/category';
import { MultiUtilityService } from '../../core/services/multi-utility.service';
import { Listing } from '../../core/models/listing';
import { HideImage } from '../../core/models/hideImage';
import { SpeakerService } from '../../core/services/speaker.service';
import { ExportImportSpeakersService } from '../../core/services/export-import-speakers.service';
import { Speaker } from '../../core/models/speaker';

import { MultiUtility } from '../../shared/multi-utility';
import * as firebase from 'firebase/app';
import { NewPageService } from '../../templates/new-page/service/new-page.service';

/** new added */
import * as XLSX from 'xlsx';
import { FileUpload, Checkbox } from 'primeng/primeng';
import { DatePipe } from '@angular/common';
import { EventsService } from '../../core/services/events.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-speaker-list',
  templateUrl: './speaker-list.component.html',
  styleUrls: ['./speaker-list.component.css'],
  providers: [
    ExtraService,
    UtilityService,
    SpeakerService,
    ExportImportSpeakersService,
    DatePipe,
    EventsService,
    NewPageService,
  ],
})
export class SpeakerListComponent extends MultiUtility implements OnInit {
  @ViewChild('bulkPhotoUploaderEl') bulkPhotoUploader;
  @ViewChild('speakerContainer') speakerContainer;

  eventID: string;
  message: string;

  categoryItemNewText: string = null;
  categoryList: Array<Category> = new Array();
  categoryDeletedIdList: Array<string> = new Array();

  speakerId: string;
  speakersList: Array<Speaker> = [];
  speakersListClone: Array<any> = [];

  checkData: boolean = false;

  hasListOrderChanged: boolean = false;
  hasCategoryOrderChanged: boolean = false;

  listing = new Listing();
  hideImage = new HideImage();

  /** new added */
  errorMessages: string;
  allSpeakers = new Array<Speaker>();
  newImportSpeakers = new Array<Speaker>();
  selectedFile: File = null;
  aliasId: string;

  keys = {
    id: 'Id',
    prefix: 'Prefix',
    name: 'Name',
    type: 'Type',
    email: 'Email',
    phoneNo: 'Phone No',
    designation: 'Designation',
    organization: 'Organization',
    isEmailVisible: 'Is Email Visible',
    isPhoneNumberVisible: 'Is Phone Visible',
  };

  /* Check all to delete start */
  checkAll: boolean = false;
  checkedList: Array<any> = new Array();
  /* Check all to delete end */

  /* drag n drop for list start */
  dropzoneActive: boolean = false;
  bannerImageFile: File = null;
  speaker = new Speaker();
  /* drag n drop for list end */

  /* list of bulk uploaded images */
  bulkUploadImages: Array<any> = new Array();

  constructor(
    extraService: ExtraService,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    multiUtilityService: MultiUtilityService,
    private speakerService: SpeakerService,
    private eximSpeakersService: ExportImportSpeakersService,
    private eventsService: EventsService,
    newPageService: NewPageService,
    _cfr: ComponentFactoryResolver,
    private _multiUtilityService: MultiUtilityService,
    private cdRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
  ) {
    super(multiUtilityService, extraService, newPageService, _cfr);
  }

  ngOnInit() {
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
    this.route.params.subscribe(params => {
      if (params['eventId']) {
        this.eventID = params['eventId'];
        this.extraService.setCurrentEventId(params['eventId']);
        this.checkData = true;
        this.initCategoryList(params['eventId']);
        this.getSpeakersList(params['eventId']);
        this.getEventAliasId(params['eventId']);

        this._multiUtilityService
          .getPrefListing(params['eventId'], Constants.LIST_CATEGORY_SPEAKER)
          .subscribe(pref => {
            this.listing.has_category_speaker = pref;
          });

        this._multiUtilityService
          .getPrefHiding(params['eventId'], Constants.LIST_CATEGORY_SPEAKER)
          .subscribe(pref => {
            this.hideImage.hideImageSpeaker = pref;
          });
      }
    });

    const bulkUploaderElement = this.bulkPhotoUploader.nativeElement;
    const that = this;
    bulkUploaderElement.addEventListener(
      'change',
      function (event) {
        const files = bulkUploaderElement.files;
        const reader = new FileReader();
        
        that.bulkUploadImages = [];

        // Parse Images locally
        for (let i = 0, len = files.length; i < len; i++) {
          const file = files[i];
          const fileName = file.name;
          const [firstName, lastName] = fileName
            .toLowerCase()
            .replace('.jpg', '')
            .split(' ');

          const allowedImageTypes = ['image/jpeg','image/png','image/jpg'];
 
          if (allowedImageTypes.includes(file.type)) {
            const imgData = URL.createObjectURL(file);
            const thumbUrl = that.sanitizer.bypassSecurityTrustResourceUrl(imgData);
            const fileName = file.name;
            const [firstName, lastName] = fileName
              .toLowerCase()
              .replace('.jpg', '')
              .split(' ');

            console.log({thumbUrl})
            that.bulkUploadImages.push({
              file,
              speakerName: {
                firstName,
                lastName,
              },
              imgData:thumbUrl,
              imgIndex: i,
              // blob: `<img src="${imgData}" data-speaker-index="${i}" class="speaker-image-option" id="imageOption"/>`,
            });

          }
        }

        for (let i = 0; i < that.speakersList.length; i++) {
          const speakerData = that.speakersList[i];
          if(!speakerData) continue;
          const speakerOrigName = speakerData.name.toLowerCase().split(' ');
          const origFirstName = speakerOrigName[0];
          const origLastName = speakerOrigName[1];

          let possibleImages: Array<any> = [];

          // Last Name Exists
          if (origLastName) {
            possibleImages = [
              ...that.bulkUploadImages.filter(
                el =>
                  el.speakerName.lastName == origLastName &&
                  el.speakerName.firstName == origFirstName
              ),
            ];
            if (possibleImages.length > 0) {
              that.speakersListClone[i] = possibleImages;
              continue;
            }
          }

          // Comparing using First Name only
          possibleImages = [
            ...possibleImages,
            ...that.bulkUploadImages.filter(
              el => el.speakerName.firstName == origFirstName
            ),
          ];

          console.log(`Possible Images for ${origFirstName} ${origLastName}:`, possibleImages.length)

          // Keep 1st 3 Images
          if (possibleImages.length > 3)
            possibleImages = possibleImages.slice(0, 3);
          that.speakersListClone[i] = possibleImages;
        }
      },
      false
    );
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
    const el =
      this.speakerContainer.nativeElement.querySelectorAll('#imageOption');
    el.forEach(e => {
      e.addEventListener(
        'click',
        function () {
          alert('Hello');
        },
        false
      );
    });
  }

  selectSpeakerImageForUpload(evt, possibleImage, speaker, speakerIndex){
    console.log({possibleImage})
    const fileObj = possibleImage.file;
    const event = {
      files: [fileObj]
    }
    this.uploadImageNew(event, speaker, speakerIndex)
  }

  debugEvent() {}
  uploadBulkPhotos() {}

  getSpeakersList(eventId: string) {
    let x = this.speakerService.getSpeakersList(eventId);
    x.snapshotChanges().subscribe(list => {
      if (this.checkData) {
        console.log('LIST_LENGTH', list.length);
        this.speakersList = [];
        list.forEach(element => {
          let y = element.payload.toJSON() as Speaker;
          y['$key'] = element.key;
          this.speakersList[y.position] = y as Speaker;
        });
        console.log(this.speakersList);
        this.checkData = false;
        // speakerSubs$.unsubscribe();
      }
    });
  }

  /*	CATEGORY RELATED FUNCTIONS	*/
  initCategoryList(eventId) {
    this._multiUtilityService
      .getCategoryList(eventId, Constants.CATEGORY_SPEAKERS)
      .subscribe(event => {
        if (event) {
          this.categoryList = new Array();
          for (let key in event) {
            let categoryItem = new Category();
            categoryItem.$key = key;
            categoryItem.position = event[key].position;
            categoryItem.text = event[key].text;
            this.categoryList[event[key].position] = categoryItem;
          }
          console.log('initCategoryList	:	' + this.categoryList.length);
        }
      });
  }

  onCategoryTextChange() {
    console.log('jnkjn');
    this.hasCategoryOrderChanged = true;
  }

  addCategoryItem() {
    if (
      this.categoryItemNewText != null &&
      this.categoryItemNewText.trim().length > 0
    ) {
      this.hasCategoryOrderChanged = true;

      let categoryItem = new Category();
      categoryItem.$key = null;
      categoryItem.position = this.categoryList.length;
      categoryItem.text = this.categoryItemNewText;
      this.categoryList.push(categoryItem);

      // Commented by Pranav
      for (var i = 0; i < this.categoryList.length; i++) {
        this.categoryList[i].position = i;
      }

      let key = this._multiUtilityService.addCategoryItem(
        this.eventID,
        this.categoryList,
        Constants.CATEGORY_SPEAKERS
      );
      if (key) {
        this.message = 'Type Added Successfully';
        this.categoryItemNewText = null;
        setTimeout(() => {
          this.message = null;
          this.checkData = true;
        }, 1000);
      }
    }
  }

  upCategoryItem(index) {
    if (index != 0) {
      this.swapCategoryItem(index, index - 1);
    }
  }

  downCategoryItem(index) {
    if (index != this.categoryList.length - 1) {
      this.swapCategoryItem(index, index + 1);
    }
  }

  swapCategoryItem(index1, index2) {
    this.hasCategoryOrderChanged = true;

    let data = this.categoryList[index1];
    this.categoryList[index1] = this.categoryList[index2];
    this.categoryList[index2] = data;
  }

  confirmDeleteCategoryItem(item) {
    this.confirmationService.confirm({
      message: Constants.DELETE_MSG_SPEAKER + ' ' + item.text,
      accept: () => {
        this.deleteCategoryItem(item);
      },
    });
  }

  deleteCategoryItem(item) {
    this.hasCategoryOrderChanged = true;

    this.categoryDeletedIdList.push(item.$key);
    let index: number = this.categoryList.indexOf(item);
    if (index !== -1) {
      /* Remove category from List */
      this.categoryList.splice(index, 1);

      /* Reset position in categoryList */
      for (var i = 0; i < this.categoryList.length; i++) {
        this.categoryList[i].position = i;
      }
    }
  }
  /*	CATEGORY RELATED FUNCTIONS - END	*/

  /* <T> object related functions */
  upListItem(index) {
    console.log('testtt');
    if (index != 0) {
      this.swapListItem(index, index - 1);
    }
  }

  downListItem(index) {
    if (index != this.speakersList.length - 1) {
      this.swapListItem(index, index + 1);
    }
  }

  swapListItem(index1, index2) {
    this.hasListOrderChanged = true;

    let data = this.speakersList[index1];
    this.speakersList[index1] = this.speakersList[index2];
    this.speakersList[index2] = data;
  }

  confirmDeleteListItem(event: Speaker, value: string) {
    this.confirmationService.confirm({
      message: Constants.DELETE_MSG_SPEAKER(),
      accept: () => {
        this.deleteListItem(event);
      },
    });
  }

  deleteListItem(event: Speaker) {
    this.hasListOrderChanged = true;

    let index: number = this.speakersList.indexOf(event);
    if (index !== -1) {
      this.speakersList.splice(index, 1);
      for (var i = 0; i < this.speakersList.length; i++) {
        this.speakersList[i].position = i;
      }
    }

    this.speakerService
      .deleteSpeaker(event, this.eventID, this.speakersList)
      .then(res => {
        this.message = 'Speaker deleted Successfully';
        setTimeout(() => {
          this.message = null;
          this.checkData = true;
          this.getSpeakersList(this.eventID);
        }, 1000);
      })
      .catch(error => {
        console.log(error.message);
      });
  }
  /* <T> object related functions */

  submit() {
    console.log(
      '		hasCategoryOrderChanged		' +
        this.hasCategoryOrderChanged +
        'hasListOrderChanged	' +
        this.hasListOrderChanged
    );
    if (this.hasListOrderChanged) {
      /* Reset position of List from 0 */
      for (var i = 0; i < this.speakersList.length; i++) {
        this.speakersList[i].position = i;
      }

      // TODO: Use a callback
      this.speakerService.updateSpeakerPosition(
        this.eventID,
        this.speakersList
      );
      this.message = 'Speakers Updated';

      setTimeout(() => {
        this.message = null;
        this.checkData = true;
      }, 2000);
    }

    if (this.hasCategoryOrderChanged) {
      for (let i = 0; i < this.categoryList.length; i++) {
        this.categoryList[i].position = i;
      }
      let key = this._multiUtilityService.addCategoryItem(
        this.eventID,
        this.categoryList,
        Constants.CATEGORY_SPEAKERS
      );
      if (this.categoryDeletedIdList.length > 0) {
        for (let item of this.categoryDeletedIdList) {
          this._multiUtilityService
            .deleteCategoryItem(this.eventID, item, Constants.CATEGORY_SPEAKERS)
            .then(res => {
              this.message = 'Type deleted Successfully';
              if (
                this.categoryDeletedIdList.indexOf(item) ==
                this.categoryDeletedIdList.length
              ) {
                this.initCategoryList(this.eventID);
              }
            });
        }
      } else {
        this.message = 'Type ordered Successfully';
      }
      setTimeout(() => {
        this.message = null;
        this.checkData = true;
      }, 2000);
    }
    this._multiUtilityService.updatePrefListing(
      this.eventID,
      Constants.LIST_CATEGORY_SPEAKER,
      this.listing.has_category_speaker
    );
    this._multiUtilityService.updatePrefHiding(
      this.eventID,
      Constants.HIDE_IMAGE_SPEAKER,
      this.hideImage.hideImageSpeaker
    );
  }

  /** new added */
  importSpeakers(event: any, uploader: FileUpload) {
    let bulkUploadTrigger: boolean = false;
    this.selectedFile = event.files[0];
    this.eximSpeakersService.importSpeakers(this.selectedFile).then(
      speakers => {
        if (!this.validateFileNameField(speakers)) {
          this.errorMessages =
            "It seems, some records don't have name value or name length should greater or equal to three character. Please fix before update.";
          setTimeout(() => {
            this.removeFileInstance(event, uploader, 0);
            this.errorMessages = null;
          }, 2000);
        } else {
          this.allSpeakers = [];
          let allSpeakerCount: number = 0;
          // all db speakers details
          this.speakerService.getAllSpeakers(this.eventID).then(list => {
            list = list.val();
            if (list) {
              allSpeakerCount = Object.keys(list).length;
              for (let val in list) {
                this.allSpeakers[val] = list[val];
              }
            }

            // speakers operation
            this.newImportSpeakers = [];
            let detail: any,
              newSpeakerIdCount = this.validateFileData(speakers);

            if (allSpeakerCount != newSpeakerIdCount) {
              this.errorMessages =
                "It seems, you don't have latest speakers list file. Please export speakers list before update.";
              setTimeout(() => {
                this.removeFileInstance(event, uploader, 0);
                this.errorMessages = null;
              }, 2000);
            } else {
              this.message = 'Processing File';
              if (!newSpeakerIdCount) {
                speakers.forEach((speaker, key) => {
                  this.addSpeaker(speaker);
                  if (+key + 1 === speakers.length) bulkUploadTrigger = true;
                });
              } else {
                speakers.forEach((speaker, key) => {
                  // id value exist
                  if (speaker[this.keys['id']] != undefined) {
                    detail = this.allSpeakers[speaker[this.keys['id']]];
                    // update
                    detail['position'] = +speaker['__rowNum__'] - 1;
                    detail['prefix'] = this.validateExcelVal(
                      speaker,
                      this.keys['prefix']
                    );
                    detail['name'] = this.validateExcelVal(
                      speaker,
                      this.keys['name']
                    );
                    detail['type'] = this.validateExcelVal(
                      speaker,
                      this.keys['type']
                    );
                    detail['email'] = this.validateExcelVal(
                      speaker,
                      this.keys['email']
                    );
                    detail['phoneNo'] = this.validateExcelVal(
                      speaker,
                      this.keys['phoneNo']
                    );
                    detail['designation'] = this.validateExcelVal(
                      speaker,
                      this.keys['designation']
                    );
                    detail['organization'] = this.validateExcelVal(
                      speaker,
                      this.keys['organization']
                    );
                    let isEmailVisible =
                      '' +
                      this.validateExcelVal(
                        speaker,
                        this.keys['isEmailVisible']
                      );
                    detail['isEmailVisible'] = isEmailVisible
                      ? isEmailVisible.toLowerCase() == 'true'
                        ? true
                        : false
                      : false;
                    let isPhoneNumberVisible =
                      '' +
                      this.validateExcelVal(
                        speaker,
                        this.keys['isPhoneNumberVisible']
                      );
                    detail['isPhoneNumberVisible'] = isPhoneNumberVisible
                      ? isPhoneNumberVisible.toLowerCase() == 'true'
                        ? true
                        : false
                      : false;
                    this.allSpeakers[speaker[this.keys['id']]] = detail;
                  } else {
                    this.addSpeaker(speaker);
                  }
                  if (+key + 1 === speakers.length) bulkUploadTrigger = true;
                });
              }
            }

            // db operation call
            setInterval(() => {
              if (bulkUploadTrigger) {
                this.removeFileInstance(event, uploader, 0);
                this.bulkUploadSpeakers();
                bulkUploadTrigger = false;
              }
            }, 1000);
          });
        }
      },
      error => {
        this.errorMessages = error;
        setTimeout(() => {
          this.errorMessages = null;
        }, 2000);
      }
    );
  }

  removeFileInstance(event: any, uploader: FileUpload, index: number) {
    uploader.remove(event.files[0], 0);
  }

  addSpeaker(speaker: any) {
    let detail = new Speaker();
    detail.position = +speaker['__rowNum__'] - 1;
    detail.prefix = this.validateExcelVal(speaker, this.keys['prefix']);
    detail.name = this.validateExcelVal(speaker, this.keys['name']);
    detail.type = this.validateExcelVal(speaker, this.keys['type']);
    detail.email = this.validateExcelVal(speaker, this.keys['email']);
    detail.phoneNo = this.validateExcelVal(speaker, this.keys['phoneNo']);
    detail.designation = this.validateExcelVal(
      speaker,
      this.keys['designation']
    );
    detail.organization = this.validateExcelVal(
      speaker,
      this.keys['organization']
    );
    let isEmailVisible =
      '' + this.validateExcelVal(speaker, this.keys['isEmailVisible']);
    detail.isEmailVisible = isEmailVisible
      ? isEmailVisible.toLowerCase() == 'true'
        ? true
        : false
      : false;
    let isPhoneNumberVisible =
      '' + this.validateExcelVal(speaker, this.keys['isPhoneNumberVisible']);
    detail.isPhoneNumberVisible = isPhoneNumberVisible
      ? isPhoneNumberVisible.toLowerCase() == 'true'
        ? true
        : false
      : false;
    this.newImportSpeakers.push(detail);
  }

  validateExcelVal(obj: any, key: string) {
    if (typeof obj[key] == 'string') obj[key] = obj[key].trim();
    console.log(key, obj[key], 'qqqqqq');
    return obj[key] != undefined && obj[key] != '' ? obj[key] : null;
  }

  validateFileNameField(speakers: any): boolean {
    let breakLoop: boolean;
    speakers.some(el => {
      if (el[this.keys['name']] !== undefined || !breakLoop) {
        if (el[this.keys['name']] === '' || el[this.keys['name']].length < 3) {
          breakLoop = true;
        }
      } else {
        breakLoop = true;
      }
    });

    if (breakLoop) return false;
    else return true;
  }

  validateFileData(speakers: any): number {
    let count = 0;
    speakers.some(el => {
      if (el[this.keys['id']] !== undefined) {
        count++;
      }
    });
    return count;
  }

  bulkUploadSpeakers() {
    this.message = 'Speakers Import Successfully';
    if (this.allSpeakers) {
      this.speakerService.addBulkSpeakers(this.allSpeakers, this.eventID);
    }
    if (this.newImportSpeakers) {
      this.newImportSpeakers.forEach(speaker => {
        this.speakerService.addSpeakerDetails(speaker, this.eventID);
      });
    }

    setTimeout(() => {
      this.message = null;
      this.checkData = true;
      this.getSpeakersList(this.eventID);
    }, 1000);
  }

  exportSpeakers() {
    // getAll
    this.allSpeakers = [];
    let data: any;
    // all db speakers details
    this.speakerService.getAllSpeakers(this.eventID).then(list => {
      list = list.val();
      if (list) {
        for (let val in list) {
          data = {};
          data[this.keys['id']] = val;
          data[this.keys['prefix']] = list[val].prefix;
          data[this.keys['name']] = list[val].name;
          data[this.keys['type']] = list[val].type;
          data[this.keys['email']] = list[val].email;
          data[this.keys['phoneNo']] = list[val].phoneNo;
          data[this.keys['designation']] = list[val].designation;
          data[this.keys['organization']] = list[val].organization;
          data[this.keys['isEmailVisible']] = list[val].isEmailVisible
            ? 'true'
            : 'false';
          data[this.keys['isPhoneNumberVisible']] = list[val]
            .isPhoneNumberVisible
            ? 'true'
            : 'false';
          this.allSpeakers[list[val].position] = data;
        }
        this.eximSpeakersService.generateFile(
          this.allSpeakers,
          this.aliasId,
          'speakers'
        );
      }
    });
  }

  getEventAliasId(id) {
    this.eventsService.getEventBasicInfo(id).subscribe(event => {
      if (event) {
        this.aliasId = event.aliasId;
      }
    });
  }

  selectUnselectAll() {
    console.log(this.checkAll);
    if (this.checkAll) {
      let arr = [];
      this.speakersList.forEach(element => {
        // console.log(element.$key);
        arr.push(element.$key);
      });
      this.checkedList = arr;
    } else {
      this.checkedList = new Array();
    }
  }

  selectSpeaker(item) {
    console.log(item.$key);
    if (this.checkedList.indexOf(item.$key) != -1) {
      let index = this.checkedList.indexOf(item.$key);
      this.checkedList.splice(index, 1);
    } else {
      this.checkedList.push(item.$key);
    }
    console.log(this.checkedList);
  }

  confirmDeleteMultipleListItem() {
    // Get Checked Item Count
    let i = 0;
    let all_checkbox = document.querySelectorAll(
      '.poll-data input[type=checkbox]'
    );
    for (let j = 0; j < all_checkbox.length; j++) {
      if ((all_checkbox[j] as HTMLInputElement).checked) i++;
    }
    console.log(i);

    this.confirmationService.confirm({
      message: Constants.DELETE_MSG_MULTIPLE_SPEAKER(i),
      accept: () => {
        this.deleteAllSelected();
      },
    });
  }

  deleteAllSelected() {
    console.log('deleteAllSelected');
    // this.confirmDeleteListItem(event: Speaker, value: string);
    this.checkedList.forEach(element => {
      // console.log(element);
      let selectedItem = this.speakersList.find(item => item.$key === element);
      // console.log(selectedItem);
      this.deleteListItem(selectedItem);
    });
  }

  /* drag n drop for list start */

  dropHandlerNew(fileList, event, speakerIndex) {
    console.log('Speaker Index', speakerIndex);
    this.uploadImageNew(fileList, event, speakerIndex);
  }

  dropHandler(fileList, event) {
    console.log('File(s) dropped', fileList);
    console.log('Speaker List', this.speakersList);
    this.uploadImage(fileList, event);
  }
  dropzoneState($event: boolean, event) {
    //console.log("DropZoneActive",$event, event);
  }

  uploadImageNew(event, _speaker, _speakerIndex) {
    console.log('Source Logo :: ', _speaker);
    const bannerImageFile = event.files[0];
    console.log('Source bannerImageFile :: ', bannerImageFile);
    const that = this;

    this.getSpeakerById(_speaker);

    this.uploadImageToStoragePromise(
      bannerImageFile,
      firebase,
      this.speaker,
      this.eventID,
      Constants.CONTENT_M_TYPE_SPEAKERS,
      Constants.IMAGE_UPLOAD_TYPE_BANNER
    ).then(d => {
      console.log('Response from FXN', d);
      console.log(this.speaker, this.eventID, _speaker.$key, d);
      if (this.validate(this.speaker)) {
        this.speakerService
          .updateSpeakerDetails(this.speaker, this.eventID, _speaker.$key, true)
          .then(res => {
            console.log({res, speakerList: that.speakersList})
            const speakerIndex = that.speakersList.findIndex(
              s => s && (s.$key == _speaker.$key)
            );
            that.speakersList[speakerIndex] = res;
            // alert("Upload Done");
            console.log('UpdatedSpeaker', res);
            console.log('Update Successfully');
          })
          .catch(error => {
            console.log('Update Failed', error);
          });
      } else {
        console.log('Update Failed else');
      }
    });
  }

  uploadImage(event, _speaker) {
    console.log('Source Logo :: ', _speaker);
    const bannerImageFile = event.files[0];
    console.log('Source bannerImageFile :: ', bannerImageFile);
    this.getSpeakerById(_speaker);

    this.uploadImageToStoragePromise(
      bannerImageFile,
      firebase,
      this.speaker,
      this.eventID,
      Constants.CONTENT_M_TYPE_SPEAKERS,
      Constants.IMAGE_UPLOAD_TYPE_BANNER
    ).then(d => {
      console.log(this.speaker, this.eventID, _speaker.$key);
      if (this.validate(this.speaker)) {
        this.speakerService
          .updateSpeakerDetails(this.speaker, this.eventID, _speaker.$key)
          .then(res => {
            console.log('res', d);
            console.log('Update Successfully');
          })
          .catch(error => {
            console.log('Update Failed');
          });
      } else {
        console.log('Update Failed else');
      }
    });
  }

  getSpeakerById(event) {
    this.speaker = event;

    this.speaker = new Speaker();
    this.speaker.prefix = event.prefix;
    this.speaker.name = event.name;
    this.speaker.position = event.position;
    this.speaker.email = event.email === undefined ? null : event.email;
    this.speaker.type = event.type === undefined ? null : event.type;
    this.speaker.fileCMId =
      event.fileCMId === undefined ? null : event.fileCMId;
    this.speaker.profileImageUri =
      event.profileImageUri === undefined ? null : event.profileImageUri;
    this.speaker.isEmailVisible =
      event.isEmailVisible === undefined ? null : event.isEmailVisible;
    this.speaker.isPhoneNumberVisible =
      event.isPhoneNumberVisible === undefined
        ? null
        : event.isPhoneNumberVisible;
    this.speaker.isProfileImageVisible =
      event.isProfileImageVisible === undefined
        ? null
        : event.isProfileImageVisible;
    this.speaker.phoneNo = event.phoneNo === undefined ? null : event.phoneNo;
    this.speaker.organization =
      event.organization === undefined ? null : event.organization;
    this.speaker.designation =
      event.designation === undefined ? null : event.designation;

    this.speaker.aboutList =
      event.aboutList === undefined ? [] : event.aboutList;

    if (this.speaker.aboutList) {
      //
    } else {
      this.speaker.aboutList = [];
    }
    return this.speaker;
  }

  /* drag n drop for list end */
  dragEnter($event) {
    $event.target.style.border = '3px dotted red';
    console.log('Drag Enter', $event);
  }
  dragLeave($event) {
    $event.target.style.border = '';
    console.log('Drag Leave', $event);
  }
  dropDone($event) {
    $event.target.style.border = '';
    $event.target.classList.add('busy');
  }
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/event/speaker-list/speaker-list.component.ts